import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Normalize } from "styled-normalize";
import GlobalStyle from "storybook-styles/global";
import { ThemeProvider } from "styled-components";
import theme from "storybook-styles/theme";
import Header from "storybook-components/Header/HelpHeader";
import Footer from "storybook-components/Footer";
import { DiagonalFinalCta } from "storybook-components/FinalCta";
import Container from "storybook-components/Container";
import ErrorBoundary from "./ErrorBoundary";
import HiddenBanner from "storybook-components/HiddenBanner";

const BackgroundColorWrapper = styled.div`
  background-color: ${props => props.color};
  width: 100%;
`;

const Layout = ({
  children,
  fluid,
  hideDefaultCta,
  hideFooter,
  backgroundColor
}) => {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <BackgroundColorWrapper color={backgroundColor || theme.colors.white}>
        <HiddenBanner hideMarketingBanner={false} />
        <Header/>
          <Container fluid={fluid}>
            <Normalize />
            <GlobalStyle />
            <main>{children}</main>
          </Container>
          {!hideDefaultCta && (
            <DiagonalFinalCta />
          )}
          {!hideFooter && <Footer />}
        </BackgroundColorWrapper>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired
};

export default Layout;
